<template>
  <div id="L1" class="sub">
    <div class="wrapper">
      <kg-header :headerType=0 />
      <div id="content">
        <div class="inner_static">
          <div id="register">
            <h1 class="tit1">パスワードを忘れた方</h1>
            <p class="lead_upper">
              登録しているメールアドレスと生年月日を入力し「送信」ボタンを押してください。入力されたメールアドレスへ、パスワード再設定ページへのリンクをお送りします。
            </p>
            <div v-if="errorMessage.text"><label class="error_text">{{ errorMessage.text }}</label></div>
            <div v-if="validateErrorMessages">
              <div v-for="(msg,index) in validateErrorMessages" :key="index"><label class="error_text">{{msg}}</label></div>
            </div>
            <div v-if="errors.email"><label class="error_text">{{errors.email}}</label></div>
            <ul class="lst_register">
              <li>
                <div class="item">
                  <label for="email">【メールアドレス】<strong class="req">※必須</strong></label>
                </div>
                <div class="cnt">
                  <div class="ins_wrap">
                    <input type="text" v-model="mailAddress" id="email" name="email" class="int">
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <label for="bir_yy">【生年月日】<strong class="req">※必須</strong></label>
                </div>
                <div class="cnt">
                  <div class="ins_wrap">
                    <div class="bir">
                      <select id="bir_yy" name="bir_yy" class="sel"  v-model="year" >
                        <option value=""></option>
                        <option v-for="(y,index) in currentYear - yearOffset" :key="index" v-bind:value="y + yearOffset">{{y + yearOffset}}</option>
                      </select>
                      <span class="unit">年</span>
                    </div>
                    <div class="bir">
                      <select id="bir_mm" name="bir_mm" class="sel"  v-model="month" >
                        <option value=""></option>
                        <option v-for="(m,index) in 12" :key="index" v-bind:value="m">{{m}}</option>
                      </select>
                      <span class="unit">月</span>
                    </div>
                    <div class="bir">
                      <select id="bir_dd" name="bir_dd" class="sel"  v-model="day" >
                        <option value=""></option>
                        <option v-for="(d,index) in 31" :key="index" v-bind:value="d">{{d}}</option>
                      </select>
                      <span class="unit">日</span>
                    </div>
                  </div>
                  <p class="att">※会員登録時に生年月日を設定されていない方は、入力しないまま「送信する」をタップしてください。</p>
                </div>
              </li>
            </ul>
            <div class="fixed_btn_area">
              <div class="inner_static">
                <a class="btn1" @click="send()">送信する</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ローディングモーダル -->
    <kg-loading-modal ref="loadingModalRef" />
  </div>
</template>

<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {KG_URL, KG_STORAGE_KEY} from '../../constants/App'
import * as Check from '../../utils/Check'

// kagull Module
import Header from '../components/common/HomeIconHeader'
import LoadingModal from '../../components/common/LoadingModal'

export default {
  components: {
    'kg-header': Header,
    'kg-loading-modal': LoadingModal
  },
  data () {
    return {
      mailAddress: '',
      year: '',
      month: '',
      day: '',
      errors: {},
      submitDisable: false,
      /** 共通エラーメッセージ */
      errorMessage: { text: '' },
      /** 項目別エラーメッセージ */
      validateErrorMessages: {}
    }
  },
  methods: {
    send: function () {
      // パスワードリセットメール送信
      if (this.submitDisable) return
      this.submitDisable = true
      this.$refs.loadingModalRef.showModal(true)
      this.errorMessage.text = ''
      this.validateErrorMessages = {}
      this.errors = {}
      this.validatedReqire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        this.submitDisable = false
        return
      }
      App.removeLocalStorage(KG_STORAGE_KEY.USER_INFO)

      let payload = {
        email: this.mailAddress,
        year: this.year,
        month: this.zeroPadding(String(this.month), 2),
        day: this.zeroPadding(String(this.day), 2)
      }
      axios.post(KG_URL.USER + '/reset/send-mail', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            // パスワード変更メール確認画面に遷移
            this.$router.push('/kagull/user/reset/mailconfirm')
          }
          this.$refs.loadingModalRef.showModal(false)
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$refs.loadingModalRef.showModal(false)
        })
        .finally(() => {
          this.submitDisable = false
        })
    },
    validatedReqire: function () {
      if (!Check.isMail(this.mailAddress)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
      }
    },
    zeroPadding: function (str, length) {
      if (!(typeof (str) === 'string' || str instanceof String)) {
        return str
      }
      if (!str) return ''
      let diff = length - str.length
      for (let i = 0; i < diff; i++) {
        str = '0' + str
      }
      return str
    },
    handleErrorMessage: function (response) {
      if (!response || !response.data) {
        return
      }
      let modalData = {
        title: 'エラー',
        messages: response.data.errorMessage.split(/\r?\n/g),
        messageType: 'error',
        textAlign: 'left'
      }
      App.showModal(modalData)
    }
  },
  computed: {
    currentYear: function () {
      return new Date().getFullYear()
    },
    yearOffset: function () {
      // 年選択プルダウンのオフセット
      return 1899
    }
  },
  created () {
    App.removeLocalStorage(KG_STORAGE_KEY.PASSWORD_DATA)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/PasswordResetTop.vue